export default "__VITE_ASSET__IK5jN9$U__"